import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import TwitchFilledSvg from "@ant-design/icons-svg/es/asn/TwitchFilled";
import AntdIcon from "../components/AntdIcon";
var TwitchFilled = function TwitchFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TwitchFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  TwitchFilled.displayName = 'TwitchFilled';
}
export default /*#__PURE__*/React.forwardRef(TwitchFilled);